import React, { useState } from 'react';
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { useDocumentTitle, useLocalStorage } from '~/hooks';
import ProjectTaskDetailsDrawer from '../../project-tasks/ProjectTaskDetailsDrawer';
import ProjectTaskEditDrawer from '../../project-tasks/ProjectTaskEditDrawer';
import TasksBoard from './TasksBoard';
import TasksList from './TasksList';

export default function TasksTab({ project, onChange }) {
  const lastView = useLocalStorage({ key: `project_dashboard_tasks_tab_view` });
  const [view, setView] = useState(() => {
    const last = lastView.get();
    if (['list', 'board'].includes(last)) {
      return last;
    } else {
      lastView.set('list');
      return 'list';
    }
  });

  const handleViewChange = (view) => {
    setView(view);
    lastView.set(view);
  };

  const { path, url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const documentTitle = useDocumentTitle();

  function handleRedirect() {
    history.push({ pathname: url, search: location.search });
    documentTitle.set(project.name);
  }

  const [refetch, setRefetch] = useState(() => () => {});

  return (
    <>
      {(() => {
        switch (view) {
          case 'list':
            return (
              <TasksList
                project={project}
                onChange={onChange}
                onViewChange={handleViewChange}
                setRefetch={setRefetch}
              />
            );

          case 'board':
            return (
              <TasksBoard
                project={project}
                onChange={onChange}
                onViewChange={handleViewChange}
                setRefetch={setRefetch}
              />
            );

          default:
            return null;
        }
      })()}

      <Switch>
        <Route path={`${path}/:taskId/details`}>
          <ProjectTaskDetailsDrawer project={project} onClose={handleRedirect} />
        </Route>

        <Route path={`${path}/:taskId/edit`}>
          <ProjectTaskEditDrawer project={project} onClose={handleRedirect} onSaved={refetch} />
        </Route>
      </Switch>
    </>
  );
}
